<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Update Courtsey Users</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="username"
                type="text"
                name="username"
                id="username"
              />
              <label>User Name <span class="redMarkRequired">*</span></label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="alt_username"
                type="text"
                name="alt_username"
                id="alt_username"
              />
              <label>Alt. User Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cu_employee_code"
                type="text"
                name="cu_employee_code"
                id="cu_employee_code"
              />
              <label
                >Employee Code <span class="redMarkRequired">*</span></label
              >
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cu_email"
                type="cu_email"
                name="cu_email"
                id="cu_email"
                @change="validateEmail"
                @input="
                  () => {
                    isEmailValid = true;
                  }
                "
                :class="{ invalid: !isEmailValid && cu_email }"
              />
              <label>Email</label>
              <p v-if="!isEmailValid && cu_email" class="error">
                Please enter a valid email address.
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cu_mobile"
                type="text"
                name="cu_mobile"
                id="cu_mobile"
                @change="validateMobile"
                @input="
                  () => {
                    isMobileValid = true;
                  }
                "
                :class="{ invalid: !isMobileValid && mobile }"
              />
              <label>Contact No</label>
              <p v-if="!isMobileValid && cu_mobile" class="error">
                Mobile number must be digits only.
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="cu_desc"
                type="text"
                name="cu_desc"
                id="cu_desc"
              />
              <label>Remarks</label>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCourtseyGroups.length ? 'shift-up' : ''"
                >Courtsey Groups <span class="redMarkRequired">*</span></label
              >
              <multiselect
                class="selectCinemaDandD"
                v-model="selectedCourtseyGroups"
                :options="groupsList"
                :placeholder="'Courtsey Groups'"
                label="group_name"
                track-by="cg_id"
                selectLabel="Select"
                deselectLabel="✖"
                :multiple="true"
              ></multiselect>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="cu_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="courtsey-users"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      cu_id: null,
      selectedCourtseyGroups: [],
      isMobileValid: true,
      isEmailValid: true,
      username: "",
      alt_username: "",
      cu_employee_code: "",
      cu_desc: "",
      cu_email: "",
      cu_mobile: "",
      cu_is_active: "Y",
      groupsList: [],
      submitted: false,
    };
  },
  mounted() {},
  beforeMount() {
    const { cu_id } = this.$route.query;
    if (cu_id) {
      this.cu_id = cu_id;
      this.getItemsDetails(cu_id);
    }
    this.getAllCourtseyGroups();
  },
  methods: {
    validateMobile() {
      this.isMobileValid = true;
      const MobileRegex = /^[0-9]{6,11}$/;
      console.log(
        "MobileRegex.test(this.cu_mobile)",
        MobileRegex.test(this.cu_mobile)
      );
      this.isMobileValid = MobileRegex.test(this.cu_mobile);
    },
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailRegex.test(this.cu_email);
    },
    getAllCourtseyGroups: function () {
      let payload = {
        tableName: "ms_courtsey_groups",
        cg_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.groupsList = data.Records;
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getItemsDetails(cu_id) {
      let loader = this.$loading.show();
      let payload = {
        cu_id: cu_id,
      };
      MarketingService.GetSingleCourtseyUser(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            const {
              username,
              alt_username,
              cu_id,
              cu_employee_code,
              cu_desc,
              cu_email,
              cu_mobile,
              cu_is_active,
              groups,
            } = data.Records[0];
            this.username = username;
            this.alt_username = alt_username;
            this.cu_employee_code = cu_employee_code;
            this.cu_id = cu_id;
            this.cu_desc = cu_desc;
            this.cu_email = cu_email;
            this.cu_mobile = cu_mobile;
            this.cu_is_active = cu_is_active;
            this.selectedCourtseyGroups = groups;
          } else {
            this.$toasted.show(data.message || "Unable to fetch data");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.username) {
        return this.$toasted.show("Please Enter User Name");
      } else if (!this.cu_employee_code) {
        return this.$toasted.show("Please Enter Employee Code");
      } else if (!this.selectedCourtseyGroups.length) {
        return this.$toasted.show("Please Select Atleast One group");
      } else if (!this.isMobileValid && this.cu_mobile) {
        return this.$toasted.show("Enter valid Mobile");
      } else if (!this.isEmailValid && this.cu_email) {
        return this.$toasted.show("Enter valid Email");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cu_id: this.cu_id,
          username: this.username,
          alt_username: this.alt_username,
          cu_employee_code: this.cu_employee_code,
          cu_desc: this.cu_desc,
          cu_email: this.cu_email,
          cu_mobile: this.cu_mobile,
          groups: this.selectedCourtseyGroups.map((x) => x.cg_id) || [],
          cu_is_active: this.cu_is_active || "Y",
        };
        MarketingService.UpdateCourtseyUsers(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "courtsey-users",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    resetForm: function () {
      this.cu_id = null;
      this.username = "";
      this.alt_username = "";
      this.cu_employee_code = "";
      this.cu_desc = "";
      this.cu_email = "";
      this.cu_mobile = "";
      this.groups = [];
      this.cu_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style scoped>
.invalid {
  border: 1px solid red;
}
.error {
  color: red;
  font-size: 0.9em;
}
</style>




// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CourtseyComponents/CourtseyUsers/editCourtseyUsers.vue